import { useEffect } from 'react';

/**
 * Component that adds security headers via meta tags
 * For production, these should ideally be set at the server/CDN level
 */
export const SecurityHeaders = () => {
  useEffect(() => {
    // Add security-related meta tags
    const metaTags = [
      // Content Security Policy - Allows Lovable iframe and necessary resources
      {
        name: 'Content-Security-Policy',
        content: "default-src 'self' https://*.supabase.co; script-src 'self' 'unsafe-inline' 'unsafe-eval' https://*.supabase.co; style-src 'self' 'unsafe-inline'; img-src 'self' data: blob: https:; font-src 'self' data:; connect-src 'self' https://*.supabase.co wss://*.supabase.co; frame-ancestors 'self' https://lovable.app https://*.lovable.app;"
      },
      // Prevent MIME type sniffing
      {
        httpEquiv: 'X-Content-Type-Options',
        content: 'nosniff'
      },
      // XSS Protection (for older browsers)
      {
        httpEquiv: 'X-XSS-Protection',
        content: '1; mode=block'
      },
      // Referrer Policy
      {
        name: 'referrer',
        content: 'strict-origin-when-cross-origin'
      },
      // Permissions Policy
      {
        httpEquiv: 'Permissions-Policy',
        content: 'geolocation=(self), microphone=(), camera=(), payment=(), usb=(), magnetometer=(), gyroscope=(), accelerometer=()'
      }
    ];

    // Add meta tags to document head
    metaTags.forEach(tag => {
      const meta = document.createElement('meta');
      
      if (tag.name) {
        meta.name = tag.name;
      }
      if (tag.httpEquiv) {
        meta.httpEquiv = tag.httpEquiv;
      }
      meta.content = tag.content;
      
      // Add a data attribute to identify our security headers
      meta.setAttribute('data-security-header', 'true');
      
      document.head.appendChild(meta);
    });

    // Cleanup function to remove the meta tags when component unmounts
    return () => {
      const securityHeaders = document.querySelectorAll('meta[data-security-header="true"]');
      securityHeaders.forEach(header => header.remove());
    };
  }, []);

  return null;
};